import Button from "components/common/controls/Button";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import { useHistory } from "react-router-dom";
import * as routePath from "shared/constants/RoutePathConstants";

interface Props {
  classNames?: string;
  size?: "normal" | "small";
}

export default function TryForFreeButton({ classNames, size }: Props) {
  const history = useHistory();

  const handleTryForFreeClick = () => {
    history.push(routePath.SIGN_UP);
  };

  return (
    <Button
      text="GET FREE API KEY"
      radiusSize={ControlSize.Midium}
      onClick={handleTryForFreeClick}
      className={classNames ? classNames : ""}
      textSizeClass={size === "small" ? "text-xs" : ""}
    />
  );
}
